module.exports = __webpack_public_path__ + "img/1.fe82b6ff.png";